<div class="user-contracts" *ngIf="!isDashboardRoute">
  <div class="contracts-list">
    <div class="account">
      <span >{{'Cuenta' | translate}}</span>
      <div class="contract-container">
        <p-dropdown styleClass="no-border" [options]="contracts" [appendTo]="'body'" [(ngModel)]="contractSelected"
          optionLabel="refNumContrato" (onChange)="changeContract()">
          <ng-template let-item pTemplate="item">
            {{item.refNumContrato}} - {{item.nomTitular}}
          </ng-template>
        </p-dropdown>
      </div>
    </div>
    <div class="account-name">
      <p>{{contractSelected?.nomTitular ? capitalizeWord(contractSelected?.nomTitular) : 'CUENTA MONEX'}}</p>
    </div>
  </div>
  <div class="search-container">
  </div>
</div>

